import { FieldState } from '../models/field-state';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'hr-field-state-marker',
  templateUrl: './field-state-marker.component.html',
  styleUrls: ['./field-state-marker.component.less'],
  standalone: false,
})
export class FieldStateMarkerComponent implements OnInit {
  @Input()
  public field: FieldState;

  constructor() {}

  ngOnInit() {}
}
